import React, { useState, useRef, useEffect } from 'react';
import {
  IonContent,
  IonPage,
  IonImg,
  IonLabel,
  IonSlides, 
  IonSlide,
  IonIcon,
  IonButton
} from '@ionic/react';
import { globeOutline, closeOutline, iosCloseCircle } from "ionicons/icons";

import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper core and required modules
import { Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom  } from "swiper/modules";

import 'swiper/css';
import '@ionic/react/css/ionic-swiper.css';
import "swiper/css/navigation";
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';

import './Slide.css';

export const SwiperZoomModal = ({zoomModalDismiss, images, clickedImageKey }) => {

	return (
		<IonContent className="ion-padding">
			<IonIcon className="zoom-slide-close" icon={closeOutline} onClick={() => zoomModalDismiss()}/>
			<Swiper className="slider" 
				zoom= {{
					maxRatio: 5,
					toggle: true
				}}
				navigation={true} modules={[Navigation, Autoplay, Keyboard, Pagination, Scrollbar, Zoom]}
				pagination={{ clickable: true }}
				scrollbar={{ draggable: true }} 
				autoplay={false}
				keyboard={true}
         		slidesPerView={1} initialSlide={clickedImageKey} speed={400} spaceBetween={5} centeredSlides={true}
				>
				{images.map((image, i) => {
					if(!image.src.includes('undefined')) { 
						return <SwiperSlide key={i} >
							<div className="swiper-zoom-container slider-slide">
							
								<IonImg src={image.src} className="swiper-zoom-target zoom-image zoom-modal-swiper-img "/>
							
							</div>
						</SwiperSlide>
					}
				})}
			</Swiper>
			
		</IonContent>
	);
	
}